import React from 'react'
import {
  IOWidget,
  Updater,
  any,
  async,
  fromJSX,
  nothing,
} from 'widgets-for-react'
import { KnowledgeHighlightLayout } from './knowledgeHighlightLayout'
import { KnowledgeHighlightState } from './knowledgeHighlightState'

export const knowledgeHighlightWidget =
  (): IOWidget<KnowledgeHighlightState, Updater<KnowledgeHighlightState>> =>
  (knowledgeHighlightState) =>
    any<Updater<KnowledgeHighlightState>>([
      async(knowledgeHighlightState),
      knowledgeHighlightState.kind == 'unloaded'
        ? nothing()
        : fromJSX(() => (
            <KnowledgeHighlightLayout
              teaser={
                knowledgeHighlightState.kind == 'loaded'
                  ? knowledgeHighlightState.value == null
                    ? 'empty'
                    : knowledgeHighlightState.value
                  : knowledgeHighlightState.kind == 'loading'
                  ? 'loading'
                  : 'error'
              }
            />
          )),
    ])
